import { Box, Flex, ScrollArea, Stack, rem } from '@mantine/core'

import { ArticleCardWrapper } from 'components/molecules/articleCardWrapper'
import { useIsMobile } from 'hooks/useIsMobile'
import { Article } from 'interfaces/types'

type ArticleCardListProps = {
  articles: Article[]
  dataTrackingCommon: any
  readmoreArticles?: string[]
  mobileLayoutStretch?: boolean
  processClass?: {
    processRoot: string
    processBar: string
  }
}
const SingleAdvanceItem = ({
  articles,
  mobileLayoutStretch,
  dataTrackingCommon,
}: ArticleCardListProps) => {
  const isMobile = useIsMobile()
  const mobileW = 279
  const mobileGap = 16
  const litmitArticles = articles.slice(0, 5)
  const heroArticle = litmitArticles.slice(0, 1)?.[0]
  const otherArticles = litmitArticles.slice(1, 5)
  const content = (
    <Flex
      sx={(theme) => ({
        gap: rem(mobileGap),
        [theme.fn.smallerThan('sm')]: {
          '.col:first-of-type': {
            width: rem(mobileW),
          },
        },
        [theme.fn.largerThan('sm')]: {
          gap: rem(24),
          '.col': {
            width: `calc((100% - 24px)/2)`,
          },
        },
      })}
    >
      <Box className={articles.length > 1 ? 'col' : ''}>
        <ArticleCardWrapper
          className="card-item"
          article={heroArticle}
          {...dataTrackingCommon(heroArticle)}
          isMobile={isMobile}
          type="author"
          size={isMobile ? 'sm' : 'md'}
          direction={articles.length > 1 ? 'vertical' : 'horizontal'}
          hideBookmark
        />
      </Box>
      {otherArticles.length > 0 && (
        <Flex
          className="col"
          sx={(theme) => ({
            gap: rem(mobileGap),
            '.card-item': {
              width: rem(mobileW),
            },
            [theme.fn.largerThan('sm')]: {
              flexWrap: 'wrap',
              gap: rem(24),
              '.card-item': {
                width: `calc((100% - 24px)/2)`,
              },
            },
          })}
        >
          {otherArticles.map((article, idx) => (
            <ArticleCardWrapper
              key={String(idx)}
              className="card-item"
              article={article}
              {...dataTrackingCommon(heroArticle)}
              isMobile={isMobile}
              type="author"
              size={'sm'}
              direction={'vertical'}
              hideBookmark
            />
          ))}
        </Flex>
      )}
    </Flex>
  )

  return articles.length > 0 ? (
    isMobile && !mobileLayoutStretch ? (
      <ScrollArea
        w="100%"
        offsetScrollbars
        type="always"
        scrollbarSize={6}
        // classNames={
        //   processClass && {
        //     scrollbar: processClass.processRoot,
        //     thumb: processClass.processBar,
        //   }
        // }
        sx={{
          '[data-orientation="vertical"]': {
            display: 'none',
          },
        }}
        styles={(theme) => ({
          scrollbar: {
            backgroundColor: theme.colors.neutral[1],
            borderRadius: 4,
          },
          thumb: {
            backgroundColor: theme.colors.gray[3],
          },
        })}
      >
        <Box
          w={
            litmitArticles.length * mobileW +
            (litmitArticles.length - 1) * mobileGap
          }
          sx={{
            paddingBottom: rem(16),
          }}
        >
          {content}
        </Box>
      </ScrollArea>
    ) : isMobile && mobileLayoutStretch ? (
      <Stack
        spacing={20}
        sx={{
          '.card-item': {
            padding: '0 !important',
          },
        }}
      >
        {litmitArticles.map((article, idx) => (
          <ArticleCardWrapper
            key={String(idx)}
            className="card-item"
            article={article}
            {...dataTrackingCommon(heroArticle)}
            isMobile={isMobile}
            type="author"
            size={'sm'}
            hideBookmark
          />
        ))}
      </Stack>
    ) : (
      <Box>{content}</Box>
    )
  ) : null
}

export { SingleAdvanceItem }
